import { useSyncExternalStore } from 'react'
import { useI18n } from '../lib/i18n'

/** El teléfono: donde los buscadores no tienen sitio para explicar por qué campos buscan. */
const PHONE_QUERY = '(max-width: 640px)'

function subscribe(onChange: () => void) {
  const media = window.matchMedia(PHONE_QUERY)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}

const isPhone = () => window.matchMedia(PHONE_QUERY).matches

/**
 * El texto de fondo de un buscador. En pantalla ancha, el suyo —«Buscar por
 * comprador, correo u oferta…»—; en el teléfono, sólo «Buscar»: el largo se
 * corta en un campo estrecho y ocupa el sitio de lo que se escribe.
 */
export function useSearchPlaceholder(key: Parameters<ReturnType<typeof useI18n>['t']>[0]): string {
  const { t } = useI18n()
  const phone = useSyncExternalStore(subscribe, isPhone, () => false)
  return phone ? t('common.search') : t(key)
}
